import React from "react";
import { Badge, Button, Col, Form, Row } from "react-bootstrap";
import { GoGear, GoTrash } from "react-icons/go";
import UseToggle from "../../../Hooks/UseToggle";
import { useState } from "react";
import { useEffect } from "react";
import AddNewProperty from "./AddNewProperty";
import UpdateProperty from "./UpdateProperty";
import { propertyServices } from "../../../APIServices/GlobalManagements/propertyServices";
import { accountServices } from "../../../APIServices/GlobalManagements/accountServices";
import DeleteProperty from "./DeleteProperty";

const SetupAnothetProperty = ({ organizationList, currentUserData }) => {
  const toggles = UseToggle();
  const [loader, setLoader] = useState(false);
  const [accountId, setAccountId] = useState("all");
  const [properties, setProperties] = useState([]);
  const [propertyData, setPropertyData] = useState("");
  const [accountList, setAccountList] = useState([]);

  const getAccountList = async (adminId) => {
    let data = await accountServices.getAccountList(adminId, "all")
    setAccountList(data?.data || [])
  }

  const getPropertyList = async () => {
    setLoader(true)
    let data = await propertyServices.getPropertyList(accountId, "all")
    setProperties(data?.data || [])
    setLoader(false)
  }

  useEffect(() => {
    if(accountId){
      getPropertyList()
    }
  }, [accountId]);
  
  useEffect(() => {
    if (organizationList?.length === 1 && currentUserData?.roleType === "organization") {
      getAccountList(organizationList?.[0]?.adminId)
    }
  }, [organizationList]);

  return (
    <>
      <div className="h-100 d-flex flex-column">
        <div className="bg-white border-bottom px-4 py-3">
          <div className="hstack justify-content-between">
            <Form.Group className="lh-1">
              <h6 className="fw-semibold m-0 d-block">Property</h6>
              <Form.Text style={{ fontSize: 13 }} className="text-muted">
                Account store all of your passwords, credit cards, and other items.
              </Form.Text>
            </Form.Group>
            <Button variant="primary" size="sm" onClick={() => toggles.setToggle()}>
              Add New Property
            </Button>
          </div>
        </div>
        {(accountList?.length > 1 && currentUserData?.roleType === "organization") &&
          <div className="bg-white border-bottom px-4 py-3">
            <div className="hstack flex-wrap gap-2">
              <Button variant={accountId === "all" ? "primary" : "outline-primary"} size="sm" onClick={() => setAccountId("all")}>
                All Property
              </Button>
              {accountList?.map((item, index) => (
                <Button key={index} variant={accountId === item?.accountId ? "primary" : "outline-primary"} size="sm" onClick={() => setAccountId(item?.accountId)}>
                  {item?.name}
                </Button>
              ))}
            </div>
          </div>
        }
        <div className="flex-grow-1 overflow-auto p-4">
          <Row className="g-4">
            {properties?.map((item, index) => (
              <Form.Group key={index} as={Col} xxl={3} xl={4} lg={6} md={6} sm={12} className="mb-2">
                <button className={`border rounded w-100 d-block align-items-start overflow-hidden text-start p-0`}>
                  <div style={{ fontSize: 14 }} className={`border-bottom py-2 px-3 bg-light`}>
                    <div className="hstack justify-content-between">
                      <div className="fw-bold m-0 text-truncate" title={item?.name}>{item?.name}</div>
                      <div className="hstack gap-2">
                        {item?.category === "primary" ?
                          <Badge bg="primary" className="rounded-1 text-capitalize">Primary</Badge>
                          : item?.status === "inactive" &&
                          <Badge bg="outlinep-secondary" className="text-secondary rounded-1 text-capitalize">Disabled</Badge>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="bg-white py-3">
                    <div className="text-center mb-2">
                      <img src={item?.icon} alt={item?.name} style={{ height: 35, width: 35 }} />
                    </div>
                    <div style={{ fontSize: 13, height: 180 }} className="px-3 text-muted overflow-auto">
                      <p className="mb-1"><span className="fw-bold">Account Name:</span> {item?.accountName}</p>
                      <p className="mb-1"><span className="fw-bold">Domain Name:</span> <a target="_blank" href={item?.domain}>{item?.domain}</a></p>
                      <p className="mb-1">{item?.totalContact}</p>
                    </div>
                  </div>
                  <div style={{ fontSize: 14 }} className={`border-top py-2 px-3 hstack justify-content-between`}>
                    {item?.loginStatus ?
                      <span className="text-success text-center fw-bold" style={{ fontSize: 12 }}>Currently activated in to this Website / App.</span>
                      :
                      <div className="hstack gap-2">
                        <GoGear title="Update Property" onClick={(e) => { e.stopPropagation(); toggles.setToggle1(); setPropertyData(item) }} />
                        <GoTrash title="Delete Property" className="text-danger" onClick={(e) => { e.stopPropagation(); toggles.setToggle2(); setPropertyData(item) }} />
                      </div>
                    }
                  </div>
                </button>
              </Form.Group>
            ))}
          </Row>
        </div>
      </div>
      <AddNewProperty
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Property`}
        getPropertyList={getPropertyList}
        organizationList={organizationList}
        currentUserData={currentUserData}
      />
      <UpdateProperty
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Property`}
        propertyData={propertyData}
        getPropertyList={getPropertyList}
        organizationList={organizationList}
        currentUserData={currentUserData}
      />
      <DeleteProperty
        show={!toggles.toggle2}
        hide={() => toggles.setToggle2()}
        title={`Delete Property Permanantly`}
        getPropertyList={getPropertyList}
      />
    </>
  );
};

export default SetupAnothetProperty;
